module.exports = {
  title: '智配金统计-用户明细',
  route: {
    path: '/finance-manage',
    children: {
      path: 'statistics-zp-sum-client-detail',
    },
  },
};
